import { PropsWithChildren, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { RoleLevel } from '@context/UserOrgCase.types';
import { useUserOrgCase } from '@context/UserOrgCaseContext';
import { useAppLocation } from '@hooks/customHooks/useAppLocation';
import { PATHS } from '@utils/paths';
import { checkPagePermission } from './utils';

export function PermissionsGuard({ children }: PropsWithChildren) {
  const navigate = useNavigate();
  const { search } = useLocation();
  const { page, urlPathname } = useAppLocation();
  const { getUserRole, isLoading } = useUserOrgCase();

  const orgRole = getUserRole(RoleLevel.organization);
  const caseRole = getUserRole(RoleLevel.case);

  const hasPermission = checkPagePermission({
    page,
    urlPathname,
    orgRole,
    caseRole,
  });

  useEffect(() => {
    if (isLoading) {
      return;
    }

    if (!hasPermission) {
      navigate({
        pathname: PATHS.PRIVATE_BASE.dashboard,
        search,
      });
    }
  }, [
    page,
    getUserRole,
    navigate,
    search,
    urlPathname,
    hasPermission,
    isLoading,
  ]);

  return children;
}
